import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Keshav </span>
            from <span className="purple"> Bihar, India.</span>
            <br />I am a pursuing Btech CSE.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Anime
            </li>
          </ul>

          <p style={{ color: "#FC0FC0" }}>
            "It is very difficult to topple a person who has learned to walk by stumbling!"{" "}
          </p>
          <footer className="blockquote-footer">kikiOP</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
